export const LEAD_STATE_PASTELS = [
  { background: '#dbeafe', color: '#1e40af' },
  { background: '#dcfce7', color: '#166534' },
  { background: '#fef3c7', color: '#92400e' },
  { background: '#fce7f3', color: '#9d174d' },
  { background: '#ede9fe', color: '#5b21b6' },
  { background: '#ffedd5', color: '#9a3412' },
  { background: '#ccfbf1', color: '#115e59' },
  { background: '#fae8ff', color: '#86198f' },
] as const;

export type LeadChipColor = { background: string; color: string };

export function pastelByIndex(index: number): LeadChipColor {
  const size = LEAD_STATE_PASTELS.length;
  const n = ((index % size) + size) % size;
  return LEAD_STATE_PASTELS[n];
}

export function pastelFromBackground(background: string | null | undefined, index = 0): LeadChipColor {
  const key = (background ?? '').trim().toLowerCase();
  return LEAD_STATE_PASTELS.find((item) => item.background === key) ?? pastelByIndex(index);
}

export function nextPastel(used: string[]): LeadChipColor {
  const taken = new Set(used.map((color) => color.toLowerCase()));
  return LEAD_STATE_PASTELS.find((item) => !taken.has(item.background)) ?? pastelByIndex(used.length);
}
